import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

export function login(body) {

    var self = this;

    var config = {
        headers: {
            "Content-Type": 'application/json'
        }
    }
    
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/emsweb/userlogin", body, config).then(resposta => {
           
                resolve(resposta.data)
            
        })
    })
}